import React from "react";
import "./Footer.css";
export default function Footer() {
  return (
    <p>
      This project was coded by Julie and is{" "}
      <a
        href="https://github.com/juliedrgn/weather-app"
        target="_blank"
        rel="noreferrer"
      >
        open-sourced on GitHub
      </a>
    </p>
  );
}
